<style lang="css">
  .list-warp {
    padding:0.3rem
  }
</style>
<template>
  <div class="wzPage--home">
      <home-head></home-head>
      
      <home-my-combat v-if="transDate"></home-my-combat>
      
      <home-updown></home-updown>

      <k-hr skin="inherit" />
      <wx-remind v-if="isValid" />

      <home-tody-rank></home-tody-rank>
      <home-total-rank></home-total-rank>
      <div style="height:1.3rem;"></div>
      <div class="firstShare" v-if="isFirst" @click="closeFirst"></div>
  </div>
</template>

<script>
  import homeHead from './mod/home-head'
  import homeMyCombat from './mod/home-my-combat'
  import homeUpdown from './mod/home-updown'
  import homeTodyRank from './mod/home-tody-rank'
  import homeTotalRank from './mod/home-total-rank'
  import wxRemind from'./mod/wx-remind'
  import { mapState, mapGetters, mapActions } from 'vuex'
  import {isInWeiXin} from '../../utils/base'
  import {WZ} from '../../common/globals'
  export default {
    data() {
      return {
        isFirst : false
      }
    },
    components:  {
      'home-head' : homeHead,
      'home-my-combat'  : homeMyCombat,
      'home-updown'     : homeUpdown,
      'home-tody-rank'  : homeTodyRank,
      'home-total-rank' : homeTotalRank,
      wxRemind
    },
    computed: {
      ...mapState('timer',['_now']),
      ...mapGetters(['myUid','myLogo']),
      ...mapGetters('account', ['isValid']),
      ...mapGetters('home', ['shangzheng','todayIsTransdate','nowTimeSection','tomorrow','nowTime','transdateList','transDate'])
      
    },
    methods: {
      ...mapActions('home', ['loadBetinfo','loadGameStatus','updateTimeSection']),
      ...mapActions('share', ['loadCheckShareGuide','loadFirstShareGuide','loadShareForCoin']),
      closeFirst(){        
        this.loadFirstShareGuide().then(() => {
          this.isFirst = false
        })
      }
    },
    async created() {
        if(this.myUid && this.transDate){
          await this.loadBetinfo()
        }
        if(isInWeiXin()){
          this.loadCheckShareGuide().then((R)=>{
            if(R.time === 0){
              this.isFirst = true
            }
          })
        }
        WZ.on("wx", "share:success", function (res){
          //alert(JSON.stringify(res, null, 2));
          // alert("微信回调成功");
          this.loadShareForCoin({
            scene : res.type
          }).then(R => {
            if(R.coinNum > 0){
              //doApi("person.all.money",{});//获取此人总的金币数目
              this.$toast('每天首次分享：金币+100,明天再来分享，还有奖励！')
            }
          })
        })
    },
    watch: {
      transDate(n){
        if(this.myUid && n){
          this.loadBetinfo()
          this.loadGameStatus()
        }
      },
      _now(n){
        //console.log(n)
        this.updateTimeSection()
      }
    },
  }
</script>
